import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import DynamicFormPage from "../../components/DynamicFormPage";
import { getStoneDetails } from "../../helpers/http_stones_requests";
import { useQuery } from "@tanstack/react-query";

export default function StoneDetails() {

    const navigate = useNavigate();

    const { id } = useParams();

    const { data, isFetching } = useQuery({ queryKey: ['getStoneDetails', id], queryFn: () => getStoneDetails(id), staleTime: 1000 * 5 });

    const { data: dataList } = data?.data ?? {};

    const formFieldList = [
        {
            title: "Informações da Pedra",
            fields: [
                {
                    name: "name",
                    label: "Nome",
                    type: "text",
                    required: true,
                },
                {
                    name: "description",
                    label: "Descrição",
                    type: "text",
                    multiline: true,
                    rows: 5,
                    fullWidth: true,
                    required: true,
                },
            ]
        },
    ];

    return <DynamicFormPage isLoading={isFetching} details initialData={dataList} title={"Pedras - Detalhes"} formFieldList={formFieldList} onCancel={() => navigate(-1)} />;
};
